// export  const API_BASE_URL = "http://localhost:8080"
export  const API_BASE_URL = "https://shatransportapi.mrtech.net.in"
export default class Constants {

    // static API_BASE_URL = "http://localhost:8080/api";
    static API_BASE_URL = "https://shatransportapi.mrtech.net.in/api";

    static END_POINT = {
        getOtp: "user/request-otp",
   
    };
}
